import React from 'react'
import { Outlet } from 'react-router-dom'
import Navbar from './Navbar'
import Footer from './Footer'
import ScrollToTop from './ScrollToTop'
import FloatingCTA from './FloatingCTA'

export default function Layout() {
  return (
    <div className="flex min-h-screen flex-col bg-white text-slate-800 antialiased">
      <ScrollToTop />
      <Navbar />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
      <FloatingCTA />
    </div>
  )
}
